export default __webpack_public_path__ + "static/media/empty-state-history.bfc3f834.svg";